// @flow

const routes = {
  '/engine/auth/start/:api': {
    fetch: () =>
      import(
        /* webpackChunkName: 'auth-engine-route' */ 'app/auth/asyncEngineRoute'
      ).then(module => module.default),
  },
};

export default routes;
